export default {
  API_BASE_URL: 'https://ttapiv1.collicare.com/collicare-tnt/v1beta1',
  // API_BASE_URL: 'https://collicare-tnt-api-test.wemade.dev/collicare-tnt/v1beta1',
  API_SYSTEMS: [
    // 'k2',
    'carlo',
    // 'sysped'
  ]
}